import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function ClosingSection() {
  return <section className="py-24 px-4 relative" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-16 font-orbitron" data-id="element-16">
          Tienes dos caminos ahora mismo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-17">
          {/* Path A */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-panel border border-red-500/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-18">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-19"></div>
            <div className="flex items-center gap-3 mb-6 text-red-500" data-id="element-20">
              <XCircleIcon size={32} data-id="element-21" />
              <h3 className="text-2xl font-bold" data-id="element-22">Camino A</h3>
            </div>
            <p className="text-gray-300 text-lg" data-id="element-23">
              No haces nada. Sigues gastando tu dinero en cosas que no importan,
              dependiendo de tus padres para siempre y llegando a los 25 años
              con estrés financiero.
            </p>
          </motion.div>

          {/* Path B */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-panel neon-box-green rounded-2xl p-8 relative overflow-hidden" data-id="element-24">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#39FF14]" data-id="element-25"></div>
            <div className="flex items-center gap-3 mb-6 text-[#39FF14]" data-id="element-26">
              <CheckCircle2Icon size={32} data-id="element-27" />
              <h3 className="text-2xl font-bold" data-id="element-28">Camino B</h3>
            </div>
            <p className="text-gray-300 text-lg" data-id="element-29">
              Inviertes el costo de un par de pizzas hoy en el Blueprint Dinero
              Pro. Cambias tu mentalidad, construyes tu primer portafolio y
              empiezas tu camino a la libertad real.
            </p>
          </motion.div>
        </div>

        <div className="text-center space-y-8" data-id="element-30">
          <p className="text-2xl font-bold text-gray-200" data-id="element-31">
            Tú decides. Nos vemos dentro.
          </p>
          <CTAButton text="SÍ, QUIERO SER UN DINERO PRO — ACCESO INMEDIATO POR $6.39" size="lg" className="w-full md:w-auto" data-id="element-32" />
        </div>
      </div>
    </section>;
}